import React from 'react';
import { Link } from 'react-router-dom';
import AuthWidget from './auth/AuthWidget';
import mgLogo from '../assets/mygate_logo.jpg';

interface AppHeaderProps {
  // Omit on pages with no sidebar (e.g. /dashboard) to hide the toggle.
  onToggleSidebar?: () => void;
  // Extreme-left back link, e.g. the dashboard's "Back to All Messages" —
  // rendered before the sidebar toggle and brand mark, not in AuthWidget's
  // right-hand slot, so it reads as leaving the page rather than an account action.
  backTo?: { to: string; label: string };
}

const BackArrowIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

// Shared top bar for every page in the app — chat and /dashboard alike —
// so signed-in status (AuthWidget) and the brand mark look identical
// everywhere rather than each page inventing its own header.
export default function AppHeader({ onToggleSidebar, backTo }: AppHeaderProps) {
  return (
    <header className="App-header">
      <div className="header-left">
        {backTo && (
          <Link to={backTo.to} className="header-back-link">
            <BackArrowIcon />
            <span>{backTo.label}</span>
          </Link>
        )}
        {onToggleSidebar && (
          <button className="header-sidebar-toggle" onClick={onToggleSidebar} title="Toggle sidebar">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        )}
        <Link to="/" className="header-brand" title="Back to Ask Anything">
          <div className="header-logo-mark">
            <img src={mgLogo} alt="Mygate" />
          </div>
          <div className="header-divider" />
          <div className="header-brand-text">
            <h1>MIRA <span>One</span></h1>
            <p>Mygate Intelligent Response Assistant</p>
          </div>
        </Link>
      </div>
      <div className="header-right">
        <AuthWidget />
      </div>
    </header>
  );
}
